import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MyAwesomeReactComponent from './MyAwesomeReactComponent';
import AppBarExampleIcon from "./AppBarExampleIcon";
class App extends Component {
  render() {

    return (
      <div className="App">
          <MuiThemeProvider>
              <AppBarExampleIcon />
          </MuiThemeProvider>
        <header className="App-header">

          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to Now Live</h1>
        </header>
        <p className="App-intro">
          Watch the Music happen <code>Live</code>.
        </p>
          <MuiThemeProvider>
              <MyAwesomeReactComponent />
          </MuiThemeProvider>




      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js